import React from 'react';
import axios from 'axios';
import * as antd from 'antd';

import ErrorCode from 'src/utils/ErrorCode';

axios.defaults.headers.common['Content-Type'] = 'application/json';

/** @typedef {import('@src/utils/types').RegistData} RegistData */
/** @typedef {import('@src/utils/types').RegisterResponse} RegisterResponse */
/** @typedef {import('@src/utils/types').User} User */
/** @typedef {import('@src/utils/types').Session} Session */

const ApiContext = React.createContext();

class ApiProvider extends React.Component {
  constructor(props) {
    super(props);

    const savedUser = localStorage.getItem('user');
    const savedSession = localStorage.getItem('session');

    this.state = {
      /**
       * @type {User} | null
       */
      user: savedUser ? JSON.parse(savedUser) : null,

      coinValue: 500,
      token: '',
      secret: '',
      version: 'v3-2025.07.14.1717',

      /**
       * @type {Session} | null
       */
      session: savedSession ? JSON.parse(savedSession) : null,

      socket: null,

      symbol: '',
      symbolScale: '',
      tokenId: '',
      accountId: '',
      // accountName: '',
      storeId: '',
      publicKey: '',
      matchPay_publicKey: '',
      isNoBinding: false,

      showWaiting: false,
      showRegister: false,
      showTranc: false,
      showWithdrawSelect: false,
      showWithdraw: false,
      showWithdrawUSDT: false,
      showTrancSelect: false,
      showTrancUSDT: false,
      showBindSelect: false,
      showOrders: false,

      api: process.env.REACT_APP_API, // 在 docker node 模式下沒有作用
      url: process.env.REACT_APP_URL, // 這個 shit 是 undefined, 必須靠 getToken 來取得資料

      ModalQR: {
        /**
         * @type string | null
         */
        Show: false,
        Title: null,
        FileName: '',
        Value: '',
      },
    };
  }

  componentDidMount() {
    // const cachedUser = localStorage.getItem('user');
    // if (cachedUser) {
    //   const parsedUser = JSON.parse(cachedUser);
    //   this.setState({ user: parsedUser }, async () => {
    //     await this.refreshUser(); // << 這裡去打 API 拿最新 user + session
    //   });
    // }
  }

  render() {
    return (
      <ApiContext.Provider
        value={{
          socket: this.state.socket,
          setSocket: (value) => this.setState({ socket: value }),

          user: this.state.user,
          setUser: (value) => this.setState({ user: value }),

          session: this.state.session,
          setSession: (value) => this.setState({ session: value }),

          coinValue: this.state.coinValue,
          setCoinValue: (coinValue) => this.setState({ coinValue }),

          showWaiting: this.state.showWaiting,
          setShowWaiting: (showWaiting) => this.setState({ showWaiting }),

          showRegister: this.state.showRegister,
          setShowRegister: (showRegister) => this.setState({ showRegister }),

          showTranc: this.state.showTranc,
          setShowTranc: (showTranc) => this.setState({ showTranc }),

          showWithdraw: this.state.showWithdraw,
          setShowWithdraw: (showWithdraw) => this.setState({ showWithdraw }),

          showWithdrawUSDT: this.state.showWithdrawUSDT,
          setShowWithdrawUSDT: (showWithdrawUSDT) =>
            this.setState({ showWithdrawUSDT }),

          showTrancSelect: this.state.showTrancSelect,
          setShowTrancSelect: (showTrancSelect) =>
            this.setState({ showTrancSelect }),

          showWithdrawSelect: this.state.showWithdrawSelect,
          setShowWithdrawSelect: (showWithdrawSelect) =>
            this.setState({ showWithdrawSelect }),

          showTrancUSDT: this.state.showTrancUSDT,
          setShowTrancUSDT: (showTrancUSDT) => this.setState({ showTrancUSDT }),

          ModalQR: this.state.ModalQR,
          setModalQR: (ModalQR) => this.setState({ ModalQR }),

          showBindSelect: this.state.showBindSelect,
          setShowBindSelect: (showBindSelect) =>
            this.setState({ showBindSelect }),

          showOrders: this.state.showOrders,
          setShowOrders: (showOrders) => this.setState({ showOrders }),

          fetchApi: this.fetchApi,
          login: this.login,
          // checkBalance: this.checkBalance,
          logout: this.logout,
          register: this.register,
          getToken: this.getToken,
          refreshUser: this.refreshUser,
          bind: this.bind,
          unbind: this.unbind,

          token: this.state.token,
          secret: this.state.secret,
          version: this.state.version,

          tokenId: this.state.tokenId,
          symbol: this.state.symbol,
          symbolScale: this.state.symbolScale,
          accountId: this.state.accountId,
          // , accountName: this.state.accountName
          storeId: this.state.storeId,
          storeName: this.state.storeName,
          isNoBinding: this.state.isNoBinding,
          publicKey: this.state.publicKey,
          matchPay_publicKey: this.state.matchPay_publicKey,
          url: this.state.url,
        }}
      >
        {this.props.children}
      </ApiContext.Provider>
    );
  }

  fetchApi = async (api, param, method) => {
    let data = null;
    if (this.state.api) {
      api = `${this.state.api}${api}`;
    }
    this.setState({ showWaiting: true });

    if (!method) method = 'POST';
    method = method.toUpperCase();

    let title = null;
    try {
      var response = null;
      switch (method) {
        case 'POST':
          response = await axios.post(api, param);
          break;
        case 'GET':
          response = await axios.get(api, param);
          break;
        default:
          break;
      }

      console.log('fetchApi', {
        request: {
          stateApi: this.state.api,
          api: api,
          method: method,
          param: param,
        },
        response: response,
      });

      if (response.data.errorCode !== ErrorCode.E_OK) {
        switch (response.data.errorCode) {
          case ErrorCode.E_ACCOUNT_NOT_EXISTS:
            throw new Error('帳號不存在或密碼錯誤');
          case ErrorCode.E_FAILED_TO_ADD_ACCOUNT:
            throw new Error('新增帳號失敗請重試');
          case ErrorCode.E_FAILED_APICALL_TO_APIBK_GETTOKEN:
            throw new Error(
              '呼叫 APIBK 的 GETTOKEN 失敗(通常是IP未加白造成或者金鑰不正確)'
            );
          case ErrorCode.E_FAILED_APICALL_TO_APIBK_BINDUSER:
            throw new Error('呼叫 APIBK 的 BINDUSER/FASTBIND 失敗');
          case ErrorCode.E_FAILED_APICALL_TO_APIBK_UNBINDUSER:
            throw new Error('呼叫 APIBK 的 UNBINDUSER 失敗');
          // case ErrorCode.E_FAILED_APICALL_TO_APIBK_TRANC:
          //   throw new Error('呼叫 APIBK 的 TRANC 失敗');
          case ErrorCode.E_FAILED_APICALL_TO_APIBK_WITHDRAW:
            // 不要拋錯，才可以繼續處理邏輯
            break;
          case ErrorCode.E_COIN_NOT_ENOUGH:
            throw new Error(response.data.msg);
          case ErrorCode.E_WALLET_NOT_BINDED:
            throw new Error('帳號未綁定任何錢包');
          case 998:
            throw new Error('系統維護中');
          case ErrorCode.E_INVALID_SESSION:
            throw new Error('登入失效請重新登入');
          case ErrorCode.E_BALANCE_NOT_ENOUGH:
            throw new Error('餘額不足');
          case ErrorCode.E_LOGINNAME_IS_DIFFERENT:
            // throw new Error('E Pay 綁定帳號不一致');
            // 不要拋錯，才可以繼續處理邏輯。但是要怎麼處理呢?
            break;
          case ErrorCode.E_BINDNAME_IS_DIFFERENT:
            // throw new Error('E Pay 綁定帳號不一致');
            // 不要拋錯，才可以繼續處理邏輯。但是要怎麼處理呢?
            break;
          case ErrorCode.E_SYSTEM_FAILURE:
            if (response.data.msg) throw new Error(response.data.msg);
            throw new Error('系統錯誤請聯絡RD');
          case ErrorCode.E_OTC_FAILED:
            title = 'E Pay 錯誤'
            throw new Error(response.data.msg);
          case ErrorCode.E_GET_ORDERS_FAILED:
            throw new Error('訂單列表錯誤')
          case ErrorCode.E_INVALID_COIN:
            throw new Error('訂單金額錯誤')
          case ErrorCode.E_MODEL_GAME_ORDER_SET_FAILED:
            title = '訂單更新錯誤'
            throw new Error(response.data.msg)
          default:
            throw new Error('未知錯誤請聯絡RD');
        }
      }

      data = response.data;
    } catch (error) {
      antd.notification.error({
        message: title??'錯誤',
        description: error.message,
      });
    }

    this.setState({ showWaiting: false });

    return data;
  };

  // checkBalance = async () => {
  //   await this.fetchApi('/api/get-balance');
  // };

  login = async (uid, password) => {
    const { id: socketId } = this.state.socket;
    console.dir('Socket', this.state.socket);
    console.log('Socket ID: ' + socketId);

    /**
     * @type {import('@src/utils/types').LoginResponse}
     */
    const loginResponse = await this.fetchApi('/api/login', { uid, password, socketId });
    if (!loginResponse) {
      // comment out: fetchApi 會處理
      // notification.error({
      //   message: i18n.t('statusbar.login'),
      //   description: i18n.t('common.error'),
      // })
      return;
    }

    // 設定 context
    this.setState({ user: loginResponse.user });
    this.setState({ session: loginResponse.session });

    // 寫入 localStorage
    localStorage.setItem('user', JSON.stringify(loginResponse.user));
    localStorage.setItem('session', JSON.stringify(loginResponse.session));
  };

  logout = async () => {
    this.setState({ user: null });
    localStorage.removeItem('user');
    localStorage.removeItem('session');
  };

  /**
   * 註冊
   * @param {RegistData} params - 用戶註冊信息
   */
  register = async (params) => {
    console.log('ApiContext: register function');

    const { uid, nickname, password, wid } = params;
    console.log(`uid: ${uid}`);
    console.log(`nickname: ${nickname}`);
    console.log(`password: ${password}`);
    console.log(`wid: ${wid}`);

    // if (wid && wid !== "") {
    //   const bindData = await this.fetchApi('/api/binduserwallet', { uid, wid });
    //   if (bindData.result.errorCode !== 0) {
    //     const errorMsg = (typeof (bindData.result.errorMessage) == "undefined") ? bindData.result.msg : bindData.result.errorMessage
    //     antd.notification.error({
    //       message: '註冊綁定錯誤',
    //       description: bindData.result.errorCode + `:` + errorMsg,
    //     });

    //     return false;
    //   }
    // }

    /**
     * @type {RegisterResponse}
     */
    const data = await this.fetchApi('/api/register', params);
    if (!data) {
      // comment out: fetchApi 會處理
      // notification.error({
      //   message: i18n.t('ModalRegister.Regist'),
      //   description: i18n.t('common.error'),
      // })
      return
    }
    // 設定 context
    this.setState({ user: data.user });
    this.setState({ session: data.session });

    // 寫入 localStorage
    localStorage.setItem('user', JSON.stringify(data.user));
    localStorage.setItem('session', JSON.stringify(data.session));
  };

  getToken = async () => {
    const data = await this.fetchApi('/api/getToken', null, 'get');
    if (data) {
      this.setState({
        // Deprecate: Yapay, Gabao
        token: data.token,
        secret: data.secret,

        accountId: data.accountId,
        // accountName: data.accountName,
        storeId: data.storeId,
        storeName: data.storeName,
        isNoBinding: data.isNoBinding,
        symbol: data.symbol,
        symbolScale: data.scale,
        tokenId: data.tokenId,
        publicKey: data.publicKey,
        matchPay_publicKey: data.matchPay_publicKey,
        url: data.url,
      });
    }
  };

  // 更新畫面
  refreshUser = async () => {
    const { user } = this.state;
    const { socket } = this.state;
    if (!user) return;

    /**
     * @typedef {import('@src/utils/types').RefreshUserResponse}
     */
    const res = await this.fetchApi(`/api/refreshUser`, {
      uid: user.uid,
      socketId: socket.id,
    });
    if (res) {
      this.setState({
        user: res.user,
        session: res.session,
      });

      localStorage.setItem('user', JSON.stringify(res.user));
      localStorage.setItem('session', JSON.stringify(res.session));
    }
    return res
  }

  bind = async (wid) => {
    const { user } = this.state;
    if (!user) return;

    user.wid = wid

    this.setState({
      user: user
    });
  }

  unbind = async () => {
    const { user } = this.state;
    if (!user) return;

    user.wid = ''

    this.setState({
      user: user
    });
  }
}

export { ApiContext, ApiProvider };
